export const incompleteStops = {
  titleStyle: {
    color: "var(--color-im-grey-900)"
  },
  margin: {
    marginBottom: "20px"
  }
};
